import { render } from "./password.vue?vue&type=template&id=51717afe&scoped=true"
import script from "./password.vue?vue&type=script&lang=js"
export * from "./password.vue?vue&type=script&lang=js"

import "./password.vue?vue&type=style&index=0&id=51717afe&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/drk-hurricane.de/test-helfer.drk-hurricane.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51717afe"]])

export default __exports__